import { createContext } from 'react';
var List2Context = createContext();
export { List2Context };